import { defineStore } from 'pinia';
// 地图容器ID常量
export const MAP_CONTAINER_ID = 'map-container';
export const useGolobalCommonStateStore = defineStore('golobalCommonState', () => {
  const currentUsedMapTool = ref(''); // 当前使用的地图工具名称
  const showNotificationPopover = ref(false); // 是否显示通知气泡
  // 设置当前使用的地图工具
  function setCurrentUsedMapTool(name) {
    currentUsedMapTool.value = name;
  }
  // 设置通知气泡的显示状态
  function setNotificationPopoverVisible(visible) {
    showNotificationPopover.value = visible;
  }
  return {
    currentUsedMapTool,
    showNotificationPopover,
    setCurrentUsedMapTool,
    setNotificationPopoverVisible
  };
});